export default __webpack_public_path__ + "static/media/logo_vertical_yellow_black.bb602180.svg";